import { useEffect, useState } from "react";
import { Logo, GoldButton } from "./shared";
import { NAV_LINKS, BOOKING_URL } from "./content";

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
                scrolled ? "glass-card py-3" : "bg-transparent py-5"
            }`}
        >
            <div className="mx-auto flex max-w-7xl items-center justify-between px-5 sm:px-8">
                <Logo />
                <nav className="hidden items-center gap-7 lg:flex" aria-label="Sections">
                    {NAV_LINKS.map((l) => (
                        <a
                            key={l.href}
                            href={l.href}
                            className="text-[13px] font-medium uppercase tracking-[0.16em] text-mist transition-colors hover:text-gold"
                        >
                            {l.label}
                        </a>
                    ))}
                </nav>
                <GoldButton href={BOOKING_URL} testId="nav-book-button" className="px-6 py-3 text-xs">
                    Book £49 Earlybird
                </GoldButton>
            </div>
        </header>
    );
}
